export const ChatUserOnlineStatus = () => <div className="absolute size-4 bg-green-400 -bottom-2 -right-2 rounded-full border-2 border-white shadow-md" />;
